import React from 'react';
import Home from "../pettiPettiMirissa/home";
import Footer from "./partials/footer";
import MainHeader from "./partials/newheader";

export default function Pettipettimain() {
  return (
    <div>
      <MainHeader />
      <Home />
      <Footer />
    </div>
  );
}
